import React from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { FormikInputField, FormRow } from "components";
import { getTaxableYear } from "utils/dates";
import { GridContainer } from "./PAIForm.css";


interface PaiMemberRowProps {
  index: number;
}

export const PaiMemberRow = ({ index }: PaiMemberRowProps) => {
  const { t } = useTranslation();
  const year =  getTaxableYear();

  return (
    <FormRow key={index}>
      <GridContainer>
        <Grid item xs={12} md={3}>
          <FormikInputField
            disabled
            label="name"
            name={`paiMembers.${index}.name`}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormikInputField
            type="number"
            label={`${t("expected_income")} ${year}`}
            name={`paiMembers.${index}.expectedIncome`}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormikInputField
            type="number"
            label={`${t("adjustments_to_income_for")} ${year}`}
            name={`paiMembers.${index}.adjustmentsIncome`}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormikInputField
            type="number"
            label={`${t("projected_annual_income_for")} ${year}`}
            name={`paiMembers.${index}.projectedAnnualIncome`}
          />
        </Grid>
      </GridContainer>
    </FormRow>
  );
};
